<template>
  <div>
    <b-form class="form profile-name">
      <b-row>
        <b-col cols="6">
          <ol>
            <li>Select Cover</li>
            <li>Select Matches (All, Fruit, Animals, Vegetables, Icons)</li>
            <li>Select Size</li>
            <li>Turn on Sound</li>
          </ol>
        </b-col>
        <b-col cols="6"> </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Settings_GamePromo",
  props: {
    publishingId: {
      type: String,
      default: null
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      getLocalPublishingWithId: "user/getLocalPublishingWithId"
    }),
    publishing(pubId) {
      return this.getLocalPublishingWithId(pubId);
    },
    settings() {
      if (this.resource && this.resource.data && this.resource.data.settings)
        return this.resource.data.settings; //TDO move to MIXIN
      return null;
    },
    video() {
      return this.resource.data &&
        this.resource.data.settings &&
        this.resource.data.settings.video &&
        this.resource.data.settings.video
        ? this.resource.data.settings.video
        : null;
    },
    videoId() {
      return this.video && this.video.videoId ? this.video.videoId : null;
    },
    videoURL() {
      return this.video && this.video.videoURL ? this.video.videoURL : null;
    },
    thumbURL() {
      return this.video && this.video.thumbURL ? this.video.thumbURL : null;
    }
  },
  data() {
    return {
      inputVideoURLDisabled: false,
      videoInputURL: null,
      storeAppleURL: null,
      storeGoogleURL: null
    };
  },
  watch: {
    publishing(newVal, oldVal) {
      //console.log(`Old: ${oldVal}`);
      //console.log(`New: ${newVal}`);
    }
  },
  methods: {
    localPublishingWithId(pubId) {
      return this.getLocalPublishingWithId(pubId);
    },
    handleAddUpdateClick() {
      //console.log(`handleAddUpdateClick URL ${this.videoInputURL}`);
      const embedData = this.getEmbedUrl(this.videoInputURL);
      //console.log(`Embed Data ${JSON.stringify(embedData)}`);

      const settings = {
        video: {
          videoURL: embedData.url,
          thumbURL: embedData.img,
          videoId: embedData.videoId,
          videoType: this.getVideoTypeFromURL(this.videoInputURL)
        }
      };
      if (this.storeAppleURL && this.storeAppleURL.length > 0)
        settings.storeAppleURL = this.storeAppleURL;
      if (this.storeGoogleURL && this.storeGoogleURL.length > 0)
        settings.storeGoogleURL = this.storeGoogleURL;

      //console.log(`Settings to Save ${settings}`);

      this.$store
        .dispatch("resources/updateResourceSettings", {
          settings: settings,
          publishingId: this.publishing.id,
          resourceId: this.resource.toolId,
          replace: true
        })
        .then(res => {
          //console.log(`Response is ${res}`);
          this.$emit("resource-updated");
        })
        .catch(error => {});
    },
    handleChange(changeMade) {
      //console.log(changeMade);
    },
    getEmbedUrl(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      //const regExp = /^.*(youtube\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      let videoId = match && match[2].length === 11 ? match[2] : null;
      return {
        url: `https://www.youtube.com/embed/${videoId}`,
        img: `https://img.youtube.com/vi/${videoId}/0.jpg`,
        videoId: videoId
      };
    },
    getVideoTypeFromURL() {
      return "youtube";
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
